import { EnumUtils } from '../../../utils/enum.utils';

export enum CompanyActionContext {
  Create = 'create',
  Edit = 'edit',
  MyCompany = 'my-company',
}

export namespace CompanyActionContext {
  export function getAllContexts(): CompanyActionContext[] {
    return EnumUtils.GetValues<CompanyActionContext>(CompanyActionContext);
  }

  export function isValid(context: null | string): boolean {
    if (context === null) {
      return false;
    }

    return getAllContexts().includes(context as CompanyActionContext);
  }
}
